import React, { Component } from "react"
import PropTypes from "prop-types"
import styled, { ThemeProvider } from "styled-components"
import isTouchDevice from "is-touch-device"
import classNames from "classnames"
import scrollToElement from "scroll-to-element"
import 'scss/main.scss'
import SEO from "utils/Seo"
import GlobalStyles from "utils/GlobalStyles";
import theme from "utils/Theme"
import Header from "components/Header/Header"
import Footer from "components/Footer/Footer"
import SocialGlobal from "components/shared/SocialGlobal"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleUp } from "@fortawesome/pro-light-svg-icons"
// import { media } from "utils/Media"

const SiteWrap = styled.div`
    &.noPadding {
        padding-top: 0 !important;
    }
`

const ScrollToTop = styled.button`
    background: ${props => props.theme.colors.primary};
    padding: .5rem;
    height: 40px;
    width: 40px;
    position: fixed;
    bottom: 1rem;
    right: 1rem;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.5rem;
    z-index: 50;
    border: 0;
    opacity: 0;
    transition: all .3s ease;
    border: 1px solid white;

    &.show {
        opacity: 1;
        visibility: visible;
    }
`

class Layout extends Component {

    constructor(props) {
        super(props)

        this.state = {
            padding: 190
        }

        this.handleFirstTab = this.handleFirstTab.bind(this)
        this.displayBackToTop = this.displayBackToTop.bind(this)
        this.scrollRef = React.createRef();
    }

    componentDidMount() {
        // this.bodyPadding()
        this.detectAnchorLinks()
        this.displayBackToTop()
        window.addEventListener('keydown', this.handleFirstTab);
        window.addEventListener('scroll', this.displayBackToTop, { passive: true });
    }
    
    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleFirstTab)
        window.removeEventListener('scroll', this.displayBackToTop, { passive: true })
    }

    displayBackToTop() {
        const windowHeight = window.innerHeight
        const bodyHeight = document.body.clientHeight
        const scrollPosiiton = window.scrollY

        if (bodyHeight > (windowHeight * 2) && scrollPosiiton > windowHeight) {
            this.scrollRef.current.classList.add('show')
        } else {
            this.scrollRef.current.classList.remove('show')
        }
    }

    scrollToTop() {
        const node = document.body
        scrollToElement(node, {
            offset: 0,
            duration: 500
        });
    }


    handleFirstTab(e) {
        if (e.keyCode === 9) { // the "I am a keyboard user" key
            document.body.classList.add('user-is-tabbing');
            window.removeEventListener('keydown', this.handleFirstTab, { passive: true });
        }
    }

    detectAnchorLinks() {
        const header = document.getElementById('siteHeader')
        const hash = window.location.hash.substr(1)
        let headerHeight = 0
        if (header) {
            headerHeight = header.offsetHeight
        }

        // On load
        if (hash !== "") {
            const node = document.getElementById(hash)
            if (node) {
                setTimeout(() => {
                    scrollToElement(node, {
                        offset: - headerHeight,
                        duration: 500
                    });
                }, 1000);
            }
        }

        // On click
        // Grab all links with hash
        const links = document.querySelectorAll('a[href*="#"]');

        // Loop links
        Array.prototype.forEach.call(links, link => {
            const id = link.href.split('#')[1]
            const node = document.getElementById(id)

            if (node) {
                // Add event listener to each
                link.addEventListener("click", function (e) {
                    e.preventDefault();
                    scrollToElement(node, {
                        offset: - headerHeight,
                        duration: 500
                    });
                });
            }
        })
    }

	render() {
		return(
			<ThemeProvider theme={theme}>
				<>
					<SEO title={this.props.seo.title} description={this.props.seo.metaDesc} image={this.props.image} path={this.props.path} />
					<GlobalStyles />
                    <SiteWrap 
                        className={classNames({
                            siteWrap: true,
                            touch: isTouchDevice(),
                            noPadding: !this.props.header
                        })}>
                        {this.props.header &&
                            <Header googleAds={this.props.googleAds} path={this.props.path} />
                        }
                        {this.props.social &&
						    <SocialGlobal />
                        }
                        <main className="content">{this.props.children}</main>
                        {this.props.footer &&
						    <Footer footerBellyband={this.props.footerBellyband} />
                        }
                        <div id="portal" />
                        <ScrollToTop ref={this.scrollRef} onClick={this.scrollToTop}>
                            <span className="sr-only">Back to top</span>
                            <FontAwesomeIcon icon={faAngleUp} />
                        </ScrollToTop>
                    </SiteWrap>
				</>
			</ThemeProvider>
		)
	}
}

export default Layout

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

Layout.defaultProps = {
    header: true,
    footer: true,
    social: true,
    footerBellyband: false
}